export default `
    <fieldset
        # if(data.id) { #
             id="#= data.id #" 
        # } #
        # if (data.classes || data.bsc) { #
             class="#= data.classes||"" # #=data.bsc||""#" 
        # } #
        # if (data.width) { #
             style="width: #= data.width #px" 
        # } # 
    >
        # if (data.header) { #
            <legend  data-label-for-id="#= data.id #" class="bind-label "data-bind="text: #= data.header #">
            </legend>
        # } #
        <div
            # if(data.containerId) { #
                 id="#= data.containerId #"
            # } #
            # if(data.containerClasses) { #
                 class="#= data.containerClasses #"
            # } # 
        >
            #= data.components #
        </div>
    </fieldset>
`;
